import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${props => props.theme.old.effects.gray};
  backdrop-filter: ${props => props.theme.old.effects.blur};
  max-width: 100%;
  z-index: 1;
  border-radius: ${props => props.block ? props.theme.old.rounded.xl : props.theme.old.rounded.xl} 0 0 ${props => props.theme.old.rounded.xl};
  color: ${props => props.theme.old.colors.white};
  font-size: ${props => props.theme.old.fontSize.header};
  font-weight: ${props =>  props.theme.old.fonts.weight.semibold};
  transition: all 300ms ease;
  display: flex;
  align-items: center;
  cursor: pointer;

  height: 50px;

  transform: ${({ $isOpen }) => $isOpen
    ? 'translateX(-200px)'
    : 'translateX(0px)'
  };
`;

export const IconWrapper = styled.div`
  padding: 8px;
  display: grid;
  place-items: center;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;

  svg {
    width: 32px;
    height: 32px;
  }
`

export const Title = styled.p`
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center start;
  padding-left: 12px;
`;


